export const buildCssClassName = (str) => {
  return str
    ?.replace(/([a-z])([A-Z])/g, '$1-$2')
    ?.replace(/[\s_]+/g, '-')
    ?.replace(/[^\w-]/g, '')
    ?.toLowerCase();
};
